// src/components/AdminPage.js (o un nuevo componente de admin para novedades)
import React, { useState, useEffect } from 'react';
import { Box, Paper, Typography, Button, Grid, Card, CardContent, Container, CardActions, IconButton, Alert, CircularProgress } from "@mui/material";
import DeleteIcon from '@mui/icons-material/Delete';
import AddNovedadModal from '../components/AddNovedadModal'; // Crearemos este modal
import api from '../api/axios';
import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import { useSnackbar } from 'notistack';
import ConfirmDeleteDialog from '../components/ConfirmDeleteDialog '; // ¡Importa el nuevo componente!


const NovedadesPage = () => {
    const { isAdmin, isAuthenticated, loading: authLoading } = useAuth();
    const navigate = useNavigate();
    const [novedades, setNovedades] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [openModal, setOpenModal] = useState(false);
    const { enqueueSnackbar } = useSnackbar();

    const [openConfirm, setOpenConfirm] = useState(false);
    const [deleteNovedad, setDeleteNovedad] = useState(null);

    const handleOpenConfirm = (novedad) => {
        setDeleteNovedad(novedad);
        setOpenConfirm(true);
    };

    const handleCloseConfirm = () => {
        setOpenConfirm(false);
        setDeleteNovedad(null);
    };

    useEffect(() => {
        if (!authLoading && !isAuthenticated) {
            navigate('/login');
        }
    }, [isAuthenticated, authLoading, navigate]);

    const fetchNovedades = async () => {
        setLoading(true);
        try {
            const res = await api.get('/Novedades/get');
            setNovedades(res.data);

        } catch (err) {
            console.error('Error al cargar novedades:', err);
            setError('Error al cargar novedades.');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchNovedades();
    }, []);

    const handleOpenModal = () => setOpenModal(true);
    const handleCloseModal = () => setOpenModal(false);

    const handleAddNovedad = async (nuevaNovedad) => {
        try {
            console.log(nuevaNovedad);

            await api.post('/Novedades/add', nuevaNovedad);
            enqueueSnackbar('Novedad agregada exitosamente.', { variant: 'success' });
            fetchNovedades(); // Recargar la lista después de agregar
        } catch (err) {
            enqueueSnackbar('Error al agregar novedad.', { variant: 'error' });
        }
    };

    const handleConfirmDelete = async () => {
        try {
            await api.delete(`/Novedades/delete/${deleteNovedad.id}`);
            setNovedades(prev => prev.filter(n => n.id !== deleteNovedad.id));
            enqueueSnackbar("Novedad eliminada exitosamente.", { variant: "success" });
        } catch (err) {
            enqueueSnackbar("Error al eliminar novedad.", { variant: "error" });
        }
        handleCloseConfirm();
    };
    // función para formatear fecha y hora


    if (isAdmin) {
        return (
            <Container maxWidth="md" sx={{ mt: 12, mb: 6 }}> {/* Ajusta el ancho y márgenes */}
                <Paper elevation={3} sx={{ p: 4, borderRadius: 3 }}>
                    {/* Header */}
                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            mb: 3,
                        }}
                    >
                        <Typography variant="h5" component="h2" sx={{ color: "primary.main", fontWeight: "bold" }}>
                            Gestión de Novedades
                        </Typography>
                        <Button variant="contained" color="primary" onClick={handleOpenModal}>
                            Agregar Novedad
                        </Button>
                    </Box>

                    {/* Loading / Error */}
                    {loading && <CircularProgress />}
                    {error && <Alert severity="error">{error}</Alert>}

                    {/* Lista de novedades */}
                    {!loading && !error && (
                        <Grid container spacing={3}>
                            {[...novedades]
                                .sort((a, b) => b.id - a.id)
                                .map((novedad) => (
                                    <Grid item xs={12} md={6} key={novedad.id}>
                                        <Card elevation={2} sx={{ borderRadius: 3, height: "100%" }}>
                                            <CardContent>
                                                {/* Título */}
                                                <Typography variant="h5" sx={{ fontWeight: "bold", mb: 1 }}>
                                                    {novedad.nombre}
                                                </Typography>

                                                {/* Fecha */}
                                                <Typography
                                                    variant="subtitle1"
                                                    sx={{ fontWeight: "bold", color: "primary.main", mb: 1 }}
                                                >
                                                    {novedad.fecha}
                                                </Typography>

                                                {/* Precio */}
                                                <Typography
                                                    variant="body2"
                                                    color="text.primary"
                                                    sx={{ whiteSpace: "pre-line" }}
                                                >
                                                    ${novedad.precio}
                                                </Typography>

                                                {/* Descripción */}
                                                <Typography
                                                    variant="body2"
                                                    color="text.secondary"
                                                    sx={{ whiteSpace: "pre-line" }}
                                                >
                                                    {novedad.descripcion}
                                                </Typography>
                                            </CardContent>

                                            <CardActions sx={{ justifyContent: "flex-end" }}>
                                                <IconButton
                                                    color="error"
                                                    onClick={() => handleOpenConfirm(novedad)}
                                                >
                                                    <DeleteIcon />
                                                </IconButton>
                                            </CardActions>
                                        </Card>
                                    </Grid>
                                ))}
                        </Grid>
                    )}
                </Paper>

                <ConfirmDeleteDialog
                    open={openConfirm}
                    title="Eliminar Novedad"
                    onClose={handleCloseConfirm}
                    onConfirm={handleConfirmDelete}
                    message={`¿Estás seguro de que quieres eliminar la novedad "${deleteNovedad?.nombre}"? Esta accion es irreversible`}
                />

                {/* Modal para agregar novedades */}
                <AddNovedadModal
                    open={openModal}
                    handleClose={handleCloseModal}
                    handleAddNovedad={handleAddNovedad}
                />
            </Container>
        );
    }
    else {
        return (
            <Container maxWidth="md" sx={{ mt: 12, mb: 6 }}> {/* Ajusta el ancho y márgenes */}
                <Typography variant="h4" component="h1" align="center" gutterBottom sx={{ mb: 4, color: 'text.primary' }}>
                    Novedades
                </Typography>
                <Paper elevation={3} sx={{ p: 4, borderRadius: 3 }}>
                    {/* Header */}
                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            mb: 3,
                        }}
                    >
                    </Box>

                    {/* Loading / Error */}
                    {loading && <CircularProgress />}
                    {error && <Alert severity="error">{error}</Alert>}

                    {/* Lista de novedades */}
                    {!loading && !error && (
                        <Grid container spacing={3}>
                            {[...novedades]
                                .sort((a, b) => b.id - a.id)
                                .map((novedad) => (
                                    <Grid item xs={12} md={6} key={novedad.id}>
                                        <Card elevation={2} sx={{ borderRadius: 3, height: "100%" }}>
                                            <CardContent>
                                                {/* Título */}
                                                <Typography variant="h5" sx={{ fontWeight: "bold", mb: 1 }}>
                                                    {novedad.nombre}
                                                </Typography>

                                                {/* Fecha */}
                                                <Typography
                                                    variant="subtitle1"
                                                    sx={{ fontWeight: "bold", color: "primary.main", mb: 1 }}
                                                >
                                                    {novedad.fecha}
                                                </Typography>

                                                {/* Precio */}
                                                <Typography
                                                    variant="body2"
                                                    color="text.primary"
                                                    sx={{ whiteSpace: "pre-line" }}
                                                >
                                                    ${novedad.precio}
                                                </Typography>

                                                {/* Descripción */}
                                                <Typography
                                                    variant="body2"
                                                    color="text.secondary"
                                                    sx={{ whiteSpace: "pre-line" }}
                                                >
                                                    {novedad.descripcion}
                                                </Typography>
                                            </CardContent>

                                            <CardActions sx={{ justifyContent: "flex-end" }}>
                                                <IconButton
                                                    color="error"
                                                    onClick={() => handleOpenConfirm(novedad)}
                                                >
                                                    <DeleteIcon />
                                                </IconButton>
                                            </CardActions>
                                        </Card>
                                    </Grid>
                                ))}
                        </Grid>
                    )}
                </Paper>


            </Container>
        )
    }
}
export default NovedadesPage;